const rPaths = {
  rPaths: {
    account: 'mi-cuenta',
    asset: 'curso',
    assets: 'mis-cursos',
    map: 'mapa',
    maps: 'mis-mapas',
    billing: 'gestion',
    clearCache: 'limpiar-cache',
    confirmForgotPassword: 'nueva-contraseña',
    initialSetup: 'configuracion-inicial',
    forgetPassword: 'recuperar-contraseña',
    login: 'login',
    notFound: 'no-encontrado',
    resetPassword: 'reset-password'
  }
}

export default rPaths
